import {
  VideoConsultCreateRoomResponse,
  VideoConsultSendInvitationRequest,
  VideoConsultSendInvitationResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class VideoConsultApi {
  public async createRoom(patientId: string): Promise<VideoConsultCreateRoomResponse> {
    const result = await trpc.client.videoConsult.createMeetingRoom.mutate({ subject: patientId });

    return result;
  }

  public async sendInvite(
    body: VideoConsultSendInvitationRequest
  ): Promise<VideoConsultSendInvitationResponse> {
    const result = await trpc.client.videoConsult.sendInvite.mutate(body);

    return result;
  }
}
